export enum ExportFormType {
	Marriage = "Marriage",
	P87 = "P87",
}

export enum ExportStageType {
	allData = "allData",
	p1 = "p1",
	p2 = "p2",
}
